import { FormatUtils } from "@my/util";
import { styled, View, XStack, YStack, Text, useWindowDimensions } from "tamagui";
import { VictoryChart, VictoryBar, VictoryLine, VictoryScatter, VictoryAxis, VictoryTooltip, VictoryGroup } from "victory";
import { jsx, jsxs } from "react/jsx-runtime";
const LegendItem = styled(YStack, {
  flexDirection: "row",
  marginHorizontal: 5,
  alignItems: "center"
});
const ColorBox = styled(YStack, {
  width: 10,
  height: 10,
  marginRight: 5,
  borderRadius: 100
});
const Legend = ({
  legendData
}) => /* @__PURE__ */jsx(XStack, {
  flexWrap: "wrap",
  children: legendData?.map(item => /* @__PURE__ */jsxs(LegendItem, {
    children: [/* @__PURE__ */jsx(ColorBox, {
      style: {
        backgroundColor: item.fill
      }
    }), /* @__PURE__ */jsx(Text, {
      fontSize: 12,
      children: item.name
    })]
  }, item.name))
});
const GroupedBarLineChart = props => {
  const {
    barData,
    legendData,
    lineData,
    colorScale
  } = props;
  const {
    width
  } = useWindowDimensions();
  const isWideScreen = width < 500;
  const chartWidth = isWideScreen ? 320 : 600;
  const chartHeight = isWideScreen ? 320 : 450;
  const barWidth = isWideScreen ? 20 : 40;
  const padding = {
    left: 60,
    right: isWideScreen ? 50 : 100,
    top: 50,
    bottom: 50
  };
  return /* @__PURE__ */jsxs(View, {
    alignItems: "flex-start",
    width: "100%",
    children: [legendData && /* @__PURE__ */jsx(Legend, {
      legendData
    }), /* @__PURE__ */jsxs(VictoryChart, {
      width: chartWidth,
      height: chartHeight,
      padding,
      children: [/* @__PURE__ */jsx(VictoryGroup, {
        offset: barData.length * 5,
        colorScale,
        children: barData.map(dataset => /* @__PURE__ */jsx(VictoryBar, {
          barWidth,
          data: dataset.data,
          x: "month",
          y: "value",
          labelComponent: /* @__PURE__ */jsx(VictoryTooltip, {}),
          labels: ({
            datum
          }) => `${dataset.name}: ${FormatUtils.currency.cashFormat(datum.value, {
            decimalPlaces: 0
          })}`
        }, dataset.name))
      }), /* @__PURE__ */jsx(VictoryLine, {
        data: lineData,
        interpolation: "natural",
        x: "month",
        y: "value",
        style: {
          data: {
            stroke: "#495057",
            strokeWidth: 2
          }
        },
        labelComponent: /* @__PURE__ */jsx(VictoryTooltip, {}),
        labels: ({
          datum
        }) => `${datum.name}: ${FormatUtils.currency.cashFormat(datum.value, {
          decimalPlaces: 0
        })}`
      }), /* @__PURE__ */jsx(VictoryScatter, {
        data: lineData,
        x: "month",
        y: "value",
        size: 5,
        style: {
          data: {
            fill: "#495057",
            stroke: "#495057",
            strokeWidth: 2
          }
        },
        labelComponent: /* @__PURE__ */jsx(VictoryTooltip, {}),
        labels: ({
          datum
        }) => `${datum.name}: ${FormatUtils.currency.cashFormat(datum.value, {
          decimalPlaces: 0
        })}`
      }), /* @__PURE__ */jsx(VictoryAxis, {
        style: {
          axis: {
            stroke: "none"
          },
          tickLabels: {
            fontSize: 12,
            fontWeight: "700"
          }
        }
      }), /* @__PURE__ */jsx(VictoryAxis, {
        dependentAxis: true,
        style: {
          axis: {
            stroke: "none"
          },
          tickLabels: {
            fontSize: 12,
            fontWeight: "700",
            marginLeft: 20
          }
        },
        tickFormat: x => {
          if (x >= 1e3) {
            return `$${x / 1e3}k`;
          }
          return `$${x}`;
        }
      })]
    })]
  });
};
export { GroupedBarLineChart };
//# sourceMappingURL=GroupedBarLineChart.mjs.map
